import React, { PureComponent } from "react";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import {
  sortNumeric,
  selectFormat,
  TableContentCell,
  getMetricForColumn,
  Error,
} from "./../../Utils/Utils.js";

const currencyFormat = (value) =>
  Intl.NumberFormat("currency-GB", {
    style: "currency",
    currency: "GBP",
  }).format(value);

class YouTubeSkyReview extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { networks: ["all"] };
  }

  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "title",
        text: "Title",
        headerClasses: "sticky-column",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        classes: "sticky-column",
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
        formatter: TableContentCell,
        csvFormatter: (cell, row) => row && (row.title || row.tweet_text || ""),
        sort: true,
      },
      {
        dataField: "video_id",
        text: "ID",
        style: { width: "90px", minWidth: "90px" },
        sort: true,
      },
      {
        dataField: "channel_title",
        text: "Channel Title",
        style: { width: "110px", minWidth: "110px" },
        sort: true,
      },

      {
        dataField: "date_pub",
        text: "Date Posted",
        style: { width: "100px", minWidth: "100px" },
        csvFormatter: (cell, row) =>
          row && moment(row.date_pub).format("YYYY-MM-DD"),
        headerAlign: "left",
        sort: true,
        csvExport: true,
        formatter: (cell, row) => {
          return moment(row.date_pub).format("YYYY-MM-DD");
        },
        sortFunc: (a, b, order) => {
          if (order === "desc") {
            return new Date(b) - new Date(a);
          } else {
            return new Date(a) - new Date(b);
          }
        },
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "estimated_revenue",
        text: "Revenue (est)",
        style: { width: "140px", minWidth: "140px" },
        formatter: (cell) => currencyFormat(cell.value),
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "$0.00a"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "estimated_ad_revenue",
        text: "Ad Revenue (est)",
        style: { width: "140px", minWidth: "140px" },
        formatter: (cell) => currencyFormat(cell.value),
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "$0.00a"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "estimated_red_partner_revenue",
        text: "Red Revenue (est)",
        style: { width: "140px", minWidth: "140px" },
        formatter: (cell) => currencyFormat(cell.value),
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "$0.00a"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "ad_impressions",
        text: "Ad Impressions",
        style: { width: "140px", minWidth: "140px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "monetized_playbacks",
        text: "Monetized Playbacks",
        style: { width: "140px", minWidth: "140px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "cpm",
        text: "CPM",
        style: { width: "110px", minWidth: "110px" },
        formatter: (cell) => currencyFormat(cell.value),
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "subscribers_gained",
        text: "Subscribers Gained",
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "subscribers_lost",
        text: "Subscribers Lost",
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      // {
      //   dataField: "viewer_percentage",
      //   text: "Viewer %",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   formatExtraData: { type: "percentage" },
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0.0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      // {
      //   dataField: "subscribers_gained",
      //   text: "Subscribers Gained",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      // {
      //   dataField: "subscribers_lost",
      //   text: "Subscribers Lost",
      //   style: { width: "100px", minWidth: "100px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },

      // {
      //   dataField: "annotation_ctr",
      //   text: "Annotation CTR",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      // {
      //   dataField: "annotation_cl_total",
      //   text: "Annotation CL",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      // {
      //   dataField: "watch_time_minutes",
      //   text: "Watch Time",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   formatExtraData: { type: "minutes", format: "0,000" },
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,000"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      // {
      //   dataField: "average_view_duration_seconds",
      //   text: "Avg Duration",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   formatExtraData: { type: "sec" },
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
      {
        dataField: "likes",
        text: "Likes",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "shares",
        text: "Shares",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "comments",
        text: "Comments",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "dislikes",
        text: "Dislikes",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      // {
      //   dataField: "estimated_minutes_watched",
      //   text: "Estimated Minutes Watched",
      //   style: { width: "120px", minWidth: "120px" },
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0,0"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },

      // {
      //   dataField: "estimated_revenue",
      //   text: "Estimated Revenue",
      //   style: { width: "120px", minWidth: "120px" },
      //   formatter: getMetricForColumn,
      //   formatExtraData: { type: "percentage" },
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0.000%"),
      //   sort: true,
      //   sortFunc: sortNumeric,
      // },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const defaultSorted = [
      {
        dataField: "date_pub",
        order: "desc",
      },
    ];

    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";

    const pagination = paginationFactory({
      sizePerPage: 15,
      hideSizePerPage: true,
    });

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            pagination={pagination}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.data.hasData === false) {
      return <Error minHeight={560} />;
    }

    return this.renderTable(data.data);
  }
}

export default YouTubeSkyReview;
